import { formatPrinterTypeLabel } from './printers';

export function formatStockQuantity(quantity) {
    const n = Number(quantity) || 0;
    return n === 1 ? '1 un.' : `${n} un.`;
}

export function printerTypeLabelForPart(part) {
    if (!part || part.applies_to_all_printers || !part.printer_brand) {
        return 'Todas';
    }
    return formatPrinterTypeLabel(part.printer_brand, part.printer_model);
}
